import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import editUserServices from '../../services/edit-users/edit-users.service';
import { OtherUserModel } from '../../models/all-user/edit-user-model';
import AppLoading from '../app-loading/app-loading';
import CategorySearch from './category-search';
import CategoryDatable from './categories-datatable';
import CategoryService from "../../services/complaintCategory/category";

const Categorydetails: React.FC = () => {
    
    const { t } = useTranslation();
    const [userList, setUserList] = useState<OtherUserModel[]>([]);
    const [refreshPage, setRefreshPage] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedKeyword, setSelectedKeyword] = useState<string>('');
    const [complaintCategories, setComplaintCategories] = useState<any[]>([]);
    const [filteredComplaintCategories, setFilteredComplaintCategories] = useState<any[]>([]); 

    useEffect(() => {
        fetchComplaintCategories(); 
      }, []);
    
    useEffect(() => {  
        handleSearch(selectedKeyword);
    }, [selectedKeyword]);

    const fetchComplaintCategories = async () => {
        try {
          const response = await CategoryService.getComplaintCategory();
          setComplaintCategories(response);
          setFilteredComplaintCategories(response); 
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      };

      const handleSearch = (keyword: string) => {
        setSelectedKeyword(keyword);
      
        const keywords = keyword.toLowerCase().trim().split(/\s+/);
      
        const filteredCategories = complaintCategories.filter((type: any) => {
          const name = (type.complaintName || "").toLowerCase();
          return keywords.every(word => name.includes(word)); 
        });
      
        setFilteredComplaintCategories(filteredCategories);
      };
      

    const reloadPage = (val:boolean)=>{
        setRefreshPage(val)
    } 
    
    
    return (
        <>
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                <h4 className="ml-1 mb-0">{t('edit_complaint_headC')}</h4>
            </div>
        <CategorySearch onSearch={setSelectedKeyword}/>
        <CategoryDatable complaintCategories={filteredComplaintCategories}/>
        </div>
     
        </>
    );
}

export default Categorydetails;

